import React from 'react';
interface Step {
  title: string;
  description?: string;
  icon?: React.ReactNode;
}
interface StepListProps {
  steps: Step[];
}
const BADGE_STYLES = ['bg-primary text-white', 'bg-brand-orange text-white', 'bg-lavande text-primary-dark'];
export function StepList({
  steps
}: StepListProps) {
  return <ol className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-531" data-mp="ds8dl56x0unm">
      {steps.map((step, index) => {
      const badgeStyle = BADGE_STYLES[index % BADGE_STYLES.length];
      return <li key={index} className="group flex flex-col items-center text-center" data-id="element-532" data-mp="nr7d9y9pdfyh" data-mpi={index}>
            <div className={`${badgeStyle} flex items-center justify-center w-16 h-16 rounded-full shadow-md mb-5 transition-transform duration-300 group-hover:scale-110`} data-id="element-533" data-mp="11gsqst4qh2z4">
              {step.icon ? <span className="animate-soft-bounce" data-id="element-534" data-mp="1be5tqvxtonwe">{step.icon}</span> : <span className="font-heading font-extrabold text-2xl" data-id="element-535" data-mp="16j08lzc8vd9d">
                  {index + 1}
                </span>}
            </div>
            <h3 className="font-heading font-bold text-lg text-primary-dark mb-2" data-id="element-536" data-mp="cn8k6rs21pdo">
              {step.title}
            </h3>
            {step.description && <p className="text-sm text-muted-foreground leading-relaxed" data-id="element-537" data-mp="hphbljpa4jdo">
                {step.description}
              </p>}
          </li>;
    })}
    </ol>;
}